import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';
 import { updateWeekAndDay } from '../../../redux/slices/protectSlice';

// Fetch previous training programs
export const fetchPreviousTrainingPrograms = createAsyncThunk(
  'training/fetchPreviousTrainingPrograms',
  async (page = 1) => {
    const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/customer/get-previous-training-programs?page=${page}`);
    return response.data.data;
  }
);

// Rename a training program
export const renameTrainingProgram = createAsyncThunk(
  'training/renameTrainingProgram',
  async ({ id, title }) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/previous-training-name-change`, {
      id,
      title
    });
    return response.data;
  }
);

// Choose a training program
export const chooseTrainingProgram = createAsyncThunk(
  'training/chooseTrainingProgram',
  async (choosedId, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/choose-training-program`, {
      choosed_id: choosedId
    });

    var payload = {"latest_week":1, "latest_day":1}
    dispatch(updateWeekAndDay(payload));

    var p = {'week_number':1,'day_number':1};
    dispatch(fetchExercisesForDayAndWeek(p));
    
    return response.data;
  }
);

export const pinExerciseNote = createAsyncThunk(
  'training/pinExerciseNote',
  async ({ id='', week_number='', day_number=''}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/pin-exercise-note`, {
      id: id,
      week_number: week_number,
      day_number:day_number
    });

    var p = {'week_number':week_number,'day_number':day_number};
    dispatch(fetchExercisesForDayAndWeek(p));
    
    return response.data;
  }
);

// Choose a training program
export const startTrainingProgram = createAsyncThunk(
  'training/startTrainingProgram',
  async ({training_program_id='', user_id=''}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/start-training-program`, {
      training_program_id: training_program_id,
      user_id: user_id
    });

    if (user_id == '') {
      dispatch(fetchTrainingWeeksDays());

      setTimeout(() => {
        var payload = {"latest_week":1, "latest_day":1}
        dispatch(updateWeekAndDay(payload));
      }, 50);
      
      
      var p = {'week_number':1,'day_number':1}
      dispatch(fetchExercisesForDayAndWeek(p));
    }
    
    return response.data;
  }
);

export const deleteExerciseFromUserProgram = createAsyncThunk(
  'training/deleteExerciseFromUserProgram',
  async ({ id='', week_number='', day_number=''}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/delete-exercise-from-user-program`, {
      id: id,
      week_number: week_number,
      day_number:day_number
    });
    
    var p = {'week_number':week_number,'day_number':day_number}
    dispatch(fetchExercisesForDayAndWeek(p));  
    
    return response.data;
  }
);

export const replaceExercise = createAsyncThunk(
  'training/replaceExercise',
  async ({ old_exercise_id='', new_exercise_id='', week_number='', day_number=''}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/replace-exercise`, {
      old_exercise_id: old_exercise_id,
      new_exercise_id:new_exercise_id,
      week_number:week_number,
      day_number:day_number
    });

    var p = {'week_number':week_number,'day_number':day_number}
    dispatch(fetchExercisesForDayAndWeek(p));  
    
    return response.data;
  }
);



export const updateExerciseNote = createAsyncThunk(
  'training/updateExerciseNote',
  async ({ exercise_id='', notes='', week_number='', day_number=''}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/update-exercise-notes`, {
      exercise_id: exercise_id,
      notes:notes,
      week_number:week_number,
      day_number:day_number
    });

    var p = {'week_number':week_number,'day_number':day_number}
    dispatch(fetchExercisesForDayAndWeek(p));    
    return response.data;
  }
);



// Choose a training program
export const fetchTrainingWeeksDays = createAsyncThunk(
  'training/fetchTrainingWeeksDays',
  async () => {
    const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/customer/training/weeks`);
    return response.data;
  }
);

// Choose a training program
export const fetchExercisesForDayAndWeek = createAsyncThunk(
  'training/fetchExercisesForDayAndWeek',
  async ({ week_number, day_number }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/customer/training/get-exercises-for-day`,
        { week_number, day_number }
      );
      return response.data;
    } catch (err) {
      // Return custom error message from API if available
      if (err.response && err.response.data && err.response.data.message) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue({ message: 'Something went wrong. Please try again.' });
    }
  }
);

export const moveExerciseUp = createAsyncThunk(
  'training/moveExerciseUp',
  async ({week_number, day_number, exercise_id, sequence, replaceable_exercise_id, replaceable_exercise_sequence}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/move-exercise-up`, {
      exercise_id: exercise_id,
      day_number: day_number,
      week_number: week_number,
      sequence:sequence,
      replaceable_exercise_id:replaceable_exercise_id,
      replaceable_exercise_sequence:replaceable_exercise_sequence
    });
    var p = {'week_number':week_number,'day_number':day_number};
    dispatch(fetchExercisesForDayAndWeek(p));
    return response.data;
  }
);

export const moveExerciseDown = createAsyncThunk(
  'training/moveExerciseDown',
   async ({week_number, day_number, exercise_id, sequence, replaceable_exercise_id, replaceable_exercise_sequence}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/move-exercise-down`, {
      exercise_id: exercise_id,
      day_number: day_number,
      week_number: week_number,
      sequence:sequence,
      replaceable_exercise_id:replaceable_exercise_id,
      replaceable_exercise_sequence:replaceable_exercise_sequence
    });
    var p = {'week_number':week_number,'day_number':day_number};
    dispatch(fetchExercisesForDayAndWeek(p));
    return response.data;
  }
);

export const updateSets = createAsyncThunk(
  'training/updateSets',
  async ({ set_index, fields, id, week_number, day_number }, { dispatch }) => {
    // Loop through the fields array and perform the update for each field
    for (let field of fields) {
      const { type, value } = field;
      
      // Make the API request for each field
      await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/update-sets/` + id, {
        set_index: set_index,
        type: type,
        value: value
      });
    }
    dispatch(fetchTrainingWeeksDays());
    //var p = { 'week_number': week_number, 'day_number': day_number };
    //dispatch(fetchExercisesForDayAndWeek(p));
  }
);

// Choose a training program
export const getWeeksOptions = createAsyncThunk(
  'training/getWeeksOptions',
  async () => {
    const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/customer/training/get-weeks-options`);
    return response.data;
  }
);

export const getProgramsOptions = createAsyncThunk(
  'training/getProgramsOptions',
  async (days=0) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/get-programs-options`, {days:days});
    return response.data;
  }
);

export const addSet = createAsyncThunk(
  'training/addSet',
  async ({id = '', week_number, day_number}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/add-set`, {id:id, week_number:week_number, day_number:day_number});
   
   // var p = { 'week_number': week_number, 'day_number': day_number };
    //dispatch(fetchExercisesForDayAndWeek(p));

    dispatch(fetchTrainingWeeksDays());
    return response.data;
  }
);

export const removeSet = createAsyncThunk(
  'training/removeSet',
  async ({id = '', week_number, day_number}, {dispatch}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/remove-set`, {id:id, week_number:week_number, day_number:day_number});
    
   // var p = { 'week_number': week_number, 'day_number': day_number };
    //dispatch(fetchExercisesForDayAndWeek(p));

    dispatch(fetchTrainingWeeksDays());
    return response.data;
  }
);

export const addNewExercise = createAsyncThunk(
  'exercise/addNewExercise',
  async ({id = '', week_number, day_number}, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/add-exercise`, {id:id, week_number:week_number, day_number:day_number});
      var p = { 'week_number': week_number, 'day_number': day_number };
      dispatch(fetchExercisesForDayAndWeek(p));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getExerciseHistory = createAsyncThunk(
  'training/getExerciseHistory',
  async ({id, training_name}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/get-exercise-history`, {id:id, training_name:training_name});
    return response.data;
  }
);

const initialState = {
  programs: [],
  status: 'idle',
  error: null,
  errorAdd:null,
  statusAdd:null,
  daysWeeks :[],
  exercises_for_day :[],
  weeks_options :[],
  programs_options :[],
  program_details: {},
  no_program_msg: '',
  loading: false,
  exercise_history: ''
};

const trainingSlice = createSlice({
  name: 'customer_training',
  initialState,
  reducers: {
    reset_weeks_options: (state, action) => {
      state.weeks_options = [];
    },
    reset_programs_options: (state, action) => {
      state.programs_options = [];
    },
    clearMessage: (state, action) => {
      state.status = 'idle';
      state.error = null;
      state.errorAdd = null;
      state.statusAdd = null;
    },
    clearHistory: (state, action) => {
      state.exercise_history = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreviousTrainingPrograms.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPreviousTrainingPrograms.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.programs = action.payload;
      })
      .addCase(fetchPreviousTrainingPrograms.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })

      .addCase(deleteExerciseFromUserProgram.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteExerciseFromUserProgram.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(deleteExerciseFromUserProgram.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })

      .addCase(pinExerciseNote.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(pinExerciseNote.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(pinExerciseNote.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })      

      .addCase(replaceExercise.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(replaceExercise.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(replaceExercise.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      }) 

      .addCase(addNewExercise.pending, (state) => {
        state.statusAdd = 'loading';
      })
      .addCase(addNewExercise.fulfilled, (state, action) => {
        state.statusAdd = 'succeeded';
      })
      .addCase(addNewExercise.rejected, (state, action) => {
        state.statusAdd = 'failed';
        state.errorAdd = action.error.message;
      })         
      
      .addCase(renameTrainingProgram.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(renameTrainingProgram.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.programs.findIndex(program => program.id === action.payload.id);
        if (index !== -1) {
          state.programs[index].program_name = action.payload.title;
        }
      })
      .addCase(renameTrainingProgram.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchExercisesForDayAndWeek.pending, (state, action) => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchExercisesForDayAndWeek.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.exercises_for_day = action.payload.data;
        state.program_details = action.payload.program_details;
         state.no_program_msg = '';
         state.loading = false;
      })
      .addCase(fetchExercisesForDayAndWeek.rejected, (state, action) => {
        state.status = 'failed';
        state.error = '';
        state.loading = false;
        // Check if message exists in payload
        const errorMessage = action.payload?.message || action.error?.message || 'Something went wrong.';
        state.no_program_msg = errorMessage;
      })

      .addCase(getWeeksOptions.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(getWeeksOptions.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.weeks_options = action.payload.data;
      })
      .addCase(getWeeksOptions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = '';
      })
      .addCase(getProgramsOptions.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(getProgramsOptions.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.programs_options = action.payload.data;
      })
      .addCase(getProgramsOptions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = '';
      })
      .addCase(getExerciseHistory.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(getExerciseHistory.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.exercise_history = action.payload.data;
      })
      .addCase(getExerciseHistory.rejected, (state, action) => {
        state.status = 'failed';
        state.exercise_history = '';
        state.error = '';
      })
      .addCase(chooseTrainingProgram.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(chooseTrainingProgram.fulfilled, (state, action, dispatch) => {
        state.status = 'succeeded';
      })
      .addCase(chooseTrainingProgram.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(startTrainingProgram.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(startTrainingProgram.fulfilled, (state, action, dispatch) => {
        state.status = 'succeeded';
      })
      .addCase(startTrainingProgram.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchTrainingWeeksDays.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTrainingWeeksDays.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.daysWeeks = action.payload.data;
      })
      .addCase(fetchTrainingWeeksDays.rejected, (state, action) => {
        state.status = 'failed';
        state.error = '';
      })
      .addCase(moveExerciseUp.fulfilled, (state, action, dispatch) => {
        state.status = 'succeeded';
      })
      .addCase(moveExerciseDown.fulfilled, (state, action, dispatch) => {
        state.status = 'succeeded';
      })
      .addCase(updateSets.fulfilled, (state, action, dispatch) => {
        state.status = 'succeeded';
      })
      .addCase(addSet.fulfilled, (state, action, dispatch) => {
        state.status = 'succeeded';
        state.exercises_for_day = action.payload.data;
        state.no_program_msg = '';
      })
      .addCase(removeSet.fulfilled, (state, action, dispatch) => {
        state.status = 'succeeded'; 
        state.exercises_for_day = action.payload.data;
        state.no_program_msg = '';
      });      
  },
});

export const { clearMessage, reset_programs_options, reset_weeks_options, clearHistory} = trainingSlice.actions;

export default trainingSlice.reducer;